import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path d="M69.493 25.655h-39c-2.7 0-4.8 2.1-4.9 4.7v39.2c0 2.7 2.1 4.8 4.7 4.9H52.393c.4 0 .8-.3.8-.7v-18c0-.4-.3-.8-.7-.8h-5.8v-4.9h5.7c.4 0 .8-.3.8-.7v-6.6c-.2-4.8 3.5-8.8 8.3-8.9H66.193v4.9h-3.3c-2.7 0-4.8 2.1-4.9 4.7v5.9c0 .4.3.8.7.8h7.1l-1.8 4.9h-5.2c-.4 0-.8.3-.8.7v18c0 .4.3.8.7.8h10.7c2.7 0 4.8-2.1 4.9-4.7v-39.2c0-2.7-2.1-4.8-4.7-4.9 0-.1 0-.1-.1-.1z" />
  </svg>
);
